const compose =
  (...fns) =>
  (val) =>
    fns.reduce((res, fn) => fn(res), val);

export default compose;
